export default (...args) => {
  args.pop();
  const sep = args.shift();
  let ret = '';
  for (let i = 0; i < args.length; i++) {
    ret += args[i].join(sep);
  }
  return ret;
};